import { render } from "./cardType.vue?vue&type=template&id=36e2ee3e&scoped=true"
import script from "./cardType.vue?vue&type=script&lang=js"
export * from "./cardType.vue?vue&type=script&lang=js"

import "./cardType.vue?vue&type=style&index=0&id=36e2ee3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36e2ee3e"

export default script